import styled, { css } from "styled-components";
import { variant as alchemyThemeVariant, borderRadius, color, typeStyle, units } from "@m/alchemy-theme";
export const Badge = styled.span `
  ${(props) => css `
    display: inline-flex;
    align-items: center;
    justify-content: center;

    ${typeStyle("captionM")};

    color: ${color("contrast", { palette: "structural" })};
    background-color: ${props.colorScheme === "alchemyLight"
    ? color("highlight")
    : props.palette && /^(expressive|illustrative)/.test(props.palette)
        ? color("a11yBase")
        : color("base")};

    min-width: 20px;

    /** update below to track parent theme somehow? */
    ${props.hasBorder && `border: 2px solid #fff;`};
    ${props.hasShadow && `box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.25);`};

    ${props.attachedTo && `position: absolute;`};
    ${alchemyThemeVariant("attachedTo", {
    topLeft: css `
        transform: translate(-50%, -50%);
        top: ${props.offset ? props.offset : 0}px;
        left: ${props.offset ? props.offset : 0}px;
      `,
    topRight: css `
        transform: translate(50%, -50%);
        top: ${props.offset ? props.offset : 0}px;
        right: ${props.offset ? props.offset : 0}px;
      `,
    bottomLeft: css `
        transform: translate(-50%, 50%);
        bottom: ${props.offset ? props.offset : 0}px;
        left: ${props.offset ? props.offset : 0}px;
      `,
    bottomRight: css `
        transform: translate(50%, 50%);
        bottom: ${props.offset ? props.offset : 0}px;
        right: ${props.offset ? props.offset : 0}px;
      `
})};

    /** TODO: consider merging with CalloutBadge */
    border-radius: ${props.variant === "square" ? borderRadius("medium") : units(1.5)};
    padding: ${props.variant === "square" ? "0" : "1px"} ${units(0.5)};
  `}
`;
export const BulletBadge = styled(Badge) `
  min-width: 10px;
  min-height: 10px;
  padding: 0;
`;
